import { render } from "./BuyFormSection.vue?vue&type=template&id=aa55fb18&scoped=true"
import script from "./BuyFormSection.vue?vue&type=script&lang=js"
export * from "./BuyFormSection.vue?vue&type=script&lang=js"

import "./BuyFormSection.vue?vue&type=style&index=0&id=aa55fb18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa55fb18"]])

export default __exports__